<template>
  <div
    class="d-flex align-center justify-center"
    style="height: calc(100vh - 236px)"
  >
    <v-card class="pa-10 pt-0 rounded-xl elevation-0" :loading="loading">
      <div class="mt-10">
        <h3>Olá {{ user.name.split(" ")[0] }},</h3>
        <p class="text-16 font-weight-medium" v-if="loading || items.length">
          Antes de começar, escolha uma empresa.
        </p>
      </div>
      <div class="w-full">
        <template v-if="loading || items.length">
          <vue-perfect-scrollbar
            :settings="{ suppressScrollX: true, wheelPropagation: false }"
            style="max-height: calc(50vh - 136px)"
          >
            <v-list>
              <v-list-item-group v-model="sOrganization">
                <v-list-item
                  v-for="item in items"
                  :key="item.id"
                  :value="item.id"
                >
                  <v-list-item-avatar size="40">
                    <base-avatar
                      :src="item.photo"
                      :seed="item.id"
                      :size="40"
                      avatarStyle="glass"
                      color="secondary lighten-2"
                    />
                  </v-list-item-avatar>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </vue-perfect-scrollbar>
          <v-btn
            v-if="hasUltimatePermission('*')"
            @click="goToUltimate"
            color="primary"
            small
            block
            depressed
            class="mt-2"
            text
          >
            <v-icon left>mdi-crown</v-icon>
            Painel Ultimate
          </v-btn>
        </template>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data: () => ({
    loading: false,
    sOrganization: "",
    items: [],
  }),
  methods: {
    ...mapActions(["changeThemeLoadingState"]),
    ...mapActions("company", ["getAllCompanies", "selectCompany"]),

    async getCompanies() {
      try {
        this.changeThemeLoadingState(true);
        this.loading = true;

        const companies = await this.getAllCompanies();

        this.items = companies;
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
        this.changeThemeLoadingState(false);
      }
    },

    goToUltimate() {
      this.selectCompany("_ultimate");
      this.$router.push({ name: "ultimate.index" });
    },
  },
  computed: {
    ...mapGetters("company", ["selectedCompany"]),
    ...mapGetters("auth", ["user", "hasUltimatePermission"]),
  },
  watch: {
    sOrganization(newValue) {
      if (newValue) {
        this.selectCompany(newValue);
        this.$router.replace({
          name: "admin.index",
        });
      }
    },
  },
  async mounted() {
    await this.getCompanies();
    if (this.selectedCompany) {
      this.sOrganization = this.selectedCompany.id;
    }
  },
};
</script>

<style></style>
